import { ApplicationHelpType, CaseFileStaticItems } from '../../../../utilities/Constants';

import CheckmateSelect from '../../../shared/CheckmateSelect';
import CheckmateSelectHelper from '../../../../utilities/CheckmateSelectHelper';
import { Help } from '../../../shared/Help';
import { IMultiSelectOption } from '../../../../interfaces/ILookup';
import { Stack } from 'react-bootstrap';
import { useDefenseCounselsLookup } from '../../../../shared/react-query-hooks/useDefenseCounselsLookup';

interface ILocalCounselControlProps {
    value: string | undefined;
    onChange: (selectedOption: IMultiSelectOption, staticItemId: number) => void;
    readonly?: boolean;
    zoneGuid: string;
}

export function LocalCounselControl(props: ILocalCounselControlProps) {
    const defenseCounselsApi = useDefenseCounselsLookup();
    const defenseCounsels = defenseCounselsApi.data ?? [];

    return (
        <Stack direction="horizontal" gap={2}>
            <div style={{ minWidth: 250, maxWidth: 300, width: '100%' }}>
                <CheckmateSelect
                    name="defenseCounsel"
                    options={CheckmateSelectHelper.getOrgOptions(defenseCounsels)}
                    onChange={(optionsList: any) =>
                        props.onChange(optionsList, CaseFileStaticItems.LocalCounsel.Id)
                    }
                    value={CheckmateSelectHelper.getSelectedOrgValue(
                        defenseCounsels,
                        props.value ?? ''
                    )}
                    isDisabled={props.readonly}
                />
            </div>

            {defenseCounselsApi.isError && (
                <Help
                    helpText={defenseCounselsApi.isError && 'Failed to load local counsels'}
                    type={ApplicationHelpType.Error}
                    title="Error"
                    iconColorVariant="red"
                />
            )}
        </Stack>
    );
}
